module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/aRYB88/tc-custom/9781459243217.jpg?1728851698311",
      "alt": "This image is the cover for the book Knight's Conquest, The Lordly Claremonts"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Knight's Conquest, The Lordly Claremonts\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Proud and beautiful, she would be no man's prize!")]), _c('br'), _c('br'), _vm._v("To the victor the spoilsOffered as the delectable prize at a jousting tournament by the King, the proud and beautiful Lady Eloise Gerrard is far from gaining the freedom to command her own destiny that she so ardently desires. Shocked to discover the King has every intention of winning the prize for himself, Eloise turns in desperation to the challenger. Sir Owain of Whitecliffe had once awoken all her youthful passionsand then heartlessly deserted her. Can she truly now wish to see him the victorthe conqueror laying claim to his prize?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Juliet Landon\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Juliet Landon is a professional embroiderer and lecturer, whose two disciplines go perfectly hand in hand. When she’s not doing one, she’s doing the other, often both on the same day. Her stories develop in her mind while stitches form on the fabric, and the one that wins depends on urgency and inclination. Juliet has been nominated for the Romantic Fiction Writer's Award, and she currently has at least another hundred ideas waiting to be released in the future.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0